<template>
  <div  class="store-item">
    <div class="coins">
      <img src="/img/coins/gold_coin.svg">
      <span>{{ numberFormatter.formatNumber(coins.sum)}}</span>
    </div>
    <div class="bonus" style="display: none">
      <span>50% Bonus</span>
    </div>
    <div class="icon">
      <img :src="coins.iconUrl">
    </div>
    <button :disabled="buyBtnDisabled" @click.prevent="buy" class="btn btn-primary w-100">{{numberFormatter.formatMoney(item.price)}}</button>
    <div class="subtext">
      <span>One time offer</span>
    </div>
  </div>
</template>
<style scoped>
.store-item {
  border-radius: var(--border-radius);
  background-color: var(--header-bg);
  padding: var(--margin-normal);
  width: calc(50% - var(--margin-xs));
  max-width: 200px;
  display: flex;
  flex-direction: column;
  gap: var(--margin-xs);
  position: relative;
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 80px;
      height: 80px;
    }
  }
  .subtext {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: #FFFFFF66;
    text-align: center;
  }

  .bonus {
    font-weight: 500;
    font-size: var(--text-size-normal);
    line-height: 20px;
    letter-spacing: 0.5%;
    text-align: center;
  }

  .coins {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--margin-xxs);
    img {
      width: 24px;
      height: 24px;
    }
    span {
      font-family: "Space Grotesk", sans-serif;
      font-weight: 700;
      font-size: var(--text-size-lg);
      line-height: 28px;
      letter-spacing: 0%;
    }
  }
}
</style>
<script lang="ts" setup>
import StoreItemDTO from "@/models/StoreItemDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed} from "vue";
import StoreCoinsDTO from "@/models/StoreCoinsDTO";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import {useRouter} from "vue-router";

const props = defineProps<{
  item: StoreItemDTO,
  buyBtnDisabled?: boolean
}>()

const store = useStore();
const router = useRouter();

const emit = defineEmits(['buy'])

const buy = () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  store.dispatch('emit', {event: AppEvents.BUY_ITEM, data: props.item})
  emit('buy', props.item)
}
const coins = computed(() => {
  return props.item.content as StoreCoinsDTO
})
</script>
